<template>
  <main class="detail">
    <div class="top-actions">
      <button class="back" @click="$router.push('/AdminAgentes')">← Todos os agentes</button>
      <button class="knowledge" @click="$router.push('/AdminAgentes/' + $route.params.id + '/Conhecimento')">
        <i class="mdi mdi-book-open-page-variant-outline"></i> Base de Conhecimento
      </button>
      <button class="knowledge" @click="$router.push('/AdminAgentes/' + $route.params.id + '/Ferramentas')">
        <i class="mdi mdi-api"></i> Ferramentas
      </button>
      <button v-if="tipo === 'INTERATIVO'" class="knowledge" @click="$router.push('/AdminAgentes/' + $route.params.id + '/Configuracao')">
        <i class="mdi mdi-tune-variant"></i> Configuração do agente
      </button>
    </div>
    <section v-if="agente" class="summary">
      <div class="heading">
        <div class="agent-icon">
          <i
            :class="
              tipo === 'INTERATIVO'
                ? 'mdi mdi-message-processing-outline'
                : 'mdi mdi-cogs'
            "
          ></i>
        </div>
        <div>
          <small>{{ tipo }}</small>
          <h1>{{ v(agente, "nome") }}</h1>
          <p>{{ v(agente, "descricao") }}</p>
        </div>
        <span>{{ v(agente, "status") }}</span>
      </div>
      <div class="summary-grid">
        <article>
          <small>{{ tipo === "INTERATIVO" ? "Interações" : "Execuções" }}</small
          ><b>{{
            num(
              tipo === "INTERATIVO"
                ? v(consumo, "interacoes")
                : v(consumo, "execucoes")
            )
          }}</b>
          <div>
            <i
              :class="
                cor(
                  progresso(tipo === 'INTERATIVO' ? 'interacoes' : 'execucoes')
                )
              "
              :style="{
                width:
                  progresso(
                    tipo === 'INTERATIVO' ? 'interacoes' : 'execucoes'
                  ) + '%',
              }"
            ></i>
          </div>
          <em>{{
            limiteTexto(
              tipo === "INTERATIVO" ? "limiteInteracoes" : "limiteExecucoes"
            )
          }}</em>
        </article>
        <article>
          <small>Tokens totais</small
          ><b>{{ num(v(consumo, "tokensTotal")) }}</b>
          <div>
            <i
              :class="cor(progresso('tokens'))"
              :style="{ width: progresso('tokens') + '%' }"
            ></i>
          </div>
          <em>{{ limiteTexto("limiteTokensTotal") }}</em>
        </article>
        <article>
          <small>Armazenamento</small
          ><b>{{ num(v(consumo, "armazenamentoMb")) }} MB</b>
          <div>
            <i
              :class="cor(progresso('armazenamento'))"
              :style="{ width: progresso('armazenamento') + '%' }"
            ></i>
          </div>
          <em>{{ limiteTexto("limiteArmazenamentoMb", " MB") }}</em>
        </article>
        <article>
          <small>Custo de IA</small><b>{{ money(v(consumo, "custoIa")) }}</b
          ><em
            >Entrada {{ num(v(consumo, "tokensEntrada")) }} · Saída
            {{ num(v(consumo, "tokensSaida")) }}</em
          >
        </article>
        <article :class="{ danger: v(erros, 'errosAbertos') }">
          <small>Erros abertos</small><b>{{ v(erros, "errosAbertos") }}</b
          ><em>{{ date(v(agente, "ultimaAtividade")) }}</em>
        </article>
      </div>
    </section>
    <section v-if="tipo === 'INTERATIVO'" class="global-refresh">
      <button class="secondary" @click="$router.push(somenteFinalizadas ? '/AdminAgentes/' + $route.params.id : '/AdminAgentes/' + $route.params.id + '/Finalizadas')">{{ somenteFinalizadas ? 'Voltar ao atendimento' : 'Conversas finalizadas' }}</button>
      <label><input v-model="autoAtualizar" type="checkbox" @change="configurarAtualizacaoAutomatica" /> Atualização automática</label>
      <label>Intervalo <input v-model.number="intervaloAtualizacaoSegundos" type="number" min="3" max="120" :disabled="!autoAtualizar" @change="configurarAtualizacaoAutomatica" /> segundos</label>
      <button type="button" class="secondary" :disabled="atualizandoConversas" @click="atualizarConversas">{{ atualizandoConversas ? 'Atualizando...' : 'Atualizar agora' }}</button>
    </section>
    <section v-if="tipo === 'INTERATIVO'" class="workspace">
      <aside :class="{ hidden: mobileDetail }">
        <div class="filters">
          <input
            v-model="busca"
            placeholder="Buscar contato"
            @keyup.enter="conversasLoad"
          /><select v-if="!somenteFinalizadas" v-model="status" @change="conversasLoad">
            <option value="">Em andamento</option><option>ABERTA</option><option>AGUARDANDO</option>
          </select><select v-model="modo" @change="conversasLoad">
            <option value="">IA e humano</option>
            <option>AGENTE</option>
            <option>HUMANO</option>
          </select>
        </div>
        <div
          v-for="c in conversas"
          :key="v(c, 'id')"
          :class="[
            'conversation',
            {
              selected: v(selecionada, 'id') === v(c, 'id'),
              human: (v(c, 'modo') || '').toUpperCase() === 'HUMANO',
            },
          ]"
          @click="abrirConversa(c)"
        >
          <div class="avatar">{{ iniciais(v(c, "contato")) }}</div>
          <div>
            <header>
              <b>{{ v(c, "contato") || v(c, "telefone") }}</b
              ><time>{{ hora(v(c, "ultimaMensagemEm")) }}</time>
            </header>
            <p>{{ v(c, "ultimaMensagem") || "Conversa sem mensagens" }}</p>
            <small>{{ v(c, "canal") }} · {{ v(c, "modo") }}</small>
          </div>
          <i v-if="v(c, 'naoLidas')">{{ v(c, "naoLidas") }}</i>
        </div>
        <div v-if="!conversas.length" class="empty">
          Nenhuma conversa encontrada.
        </div>
      </aside>
      <article
        class="conversation-panel"
        :class="{ hidden: !selecionada && mobileDetail }"
      >
        <div v-if="selecionada" class="chat">
          <header class="chat-head">
            <button class="mobile-back" @click="mobileDetail = false">←</button>
            <div>
              <b>{{ v(selecionada, "contato") }}</b
              ><small
                >{{ v(selecionada, "canal") }} ·
                {{ v(selecionada, "status") }}</small
              >
            </div>
            <button
              v-if="v(selecionada, 'modo') !== 'HUMANO'"
              @click="transferir(true)"
            >
              Assumir conversa</button
            ><button v-else class="secondary" @click="transferir(false)">Devolver para agente</button>
            <button v-if="!somenteFinalizadas" class="finish" @click="finalizarConversa">Finalizar conversa</button>
          </header>
          <section v-if="orcamento" class="quote-card">
            <header>
              <div><small>ORÇAMENTO ATUAL</small><b>{{ v(v(orcamento, "cabecalho"), "produto") }}</b></div>
              <span>{{ v(v(orcamento, "cabecalho"), "status") }}</span>
            </header>
            <div class="quote-summary">
              <strong>{{ money(v(v(orcamento, "cabecalho"), "investimento")) }}</strong>
              <small>Versão {{ v(v(orcamento, "cabecalho"), "versao") }}</small>
            </div>
            <div class="quote-items">
              <span v-for="item in v(orcamento, 'itens') || []" :key="v(item, 'id')">
                <small>{{ v(item, "tipo") }}</small>{{ v(item, "nome") }}
              </span>
            </div>
            <footer v-if="v(orcamento, 'agenda')">
              Reunião: {{ date(v(v(orcamento, "agenda"), "inicio")) }}
              <a v-if="v(v(orcamento, 'agenda'), 'meetUrl')" :href="v(v(orcamento, 'agenda'), 'meetUrl')" target="_blank">Abrir Meet</a>
            </footer>
          </section>
          <div ref="messages" class="messages">
            <div
              v-for="m in mensagens"
              :key="v(m, 'id')"
              :class="[
                'message',
                (v(m, 'direcao') || '').toUpperCase() === 'SAIDA'
                  ? 'saida'
                  : 'entrada',
              ]"
            >
              <small>{{ v(m, "autorTipo") }}</small>
              <p v-if="v(m, 'texto')">{{ v(m, "texto") }}</p>
              <audio
                v-if="ehAudio(m) && v(m, 'arquivoUrl')"
                class="message-audio"
                controls
                preload="metadata"
                crossorigin="use-credentials"
                :src="urlArquivo(v(m, 'arquivoUrl'))"
              ></audio>
              <img
                v-else-if="ehImagem(m) && v(m, 'arquivoUrl')"
                class="message-image"
                :src="urlArquivo(v(m, 'arquivoUrl'))"
                :alt="v(m, 'arquivoNome') || 'Imagem recebida'"
              />
              <a
                v-if="v(m, 'arquivoUrl') && !ehAudio(m)"
                :href="urlArquivo(v(m, 'arquivoUrl'))"
                target="_blank"
                >📎 {{ v(m, "arquivoNome") || "Abrir arquivo" }}</a
              >
              <span
                v-if="ehMidia(m) && !v(m, 'arquivoUrl')"
                class="media-unavailable"
                >Mídia ainda não vinculada ao histórico.</span
              ><time>{{ hora(v(m, "enviadaEm")) }} · {{ v(m, "status") }}</time>
            </div>
            <div v-if="!mensagens.length" class="empty">
              Nenhuma mensagem nesta conversa.
            </div>
          </div>
          <form v-if="!somenteFinalizadas" class="composer" @submit.prevent="enviar">
            <label title="Anexar arquivo"
              >📎<input type="file" @change="anexar" /></label
            ><textarea
              v-model="texto"
              :disabled="v(selecionada, 'modo') !== 'HUMANO'"
              placeholder="Assuma a conversa para responder"
            ></textarea
            ><button
              :disabled="enviando || v(selecionada, 'modo') !== 'HUMANO'"
            >
              Enviar
            </button>
          </form>
        </div>
        <div v-else class="empty central">
          Selecione uma conversa para visualizar o histórico.
        </div>
      </article>
    </section>
    <section v-if="tipo === 'EXECUTOR'" class="workspace">
      <aside :class="{ hidden: mobileDetail }">
        <div class="filters">
          <select v-model="status" @change="execucoesLoad">
            <option value="">Todos os status</option>
            <option>PENDENTE</option>
            <option>PROCESSANDO</option>
            <option>CONCLUIDA</option>
            <option>ERRO</option>
            <option>CANCELADA</option></select
          ><input type="date" v-model="dataInicio" @change="execucoesLoad" />
        </div>
        <div
          v-for="e in execucoes"
          :key="v(e, 'id')"
          :class="['execution', { selected: v(execucao, 'id') === v(e, 'id') }]"
          @click="abrirExecucao(e)"
        >
          <header>
            <b>{{ v(e, "titulo") || "Execução sem título" }}</b
            ><span :class="(v(e, 'status') || '').toLowerCase()">{{
              v(e, "status")
            }}</span>
          </header>
          <p>{{ v(e, "resumo") || v(e, "origem") || "Sem resumo" }}</p>
          <small
            >{{ date(v(e, "iniciadaEm")) }} ·
            {{ duracao(v(e, "duracaoMs")) }}</small
          >
        </div>
        <div v-if="!execucoes.length" class="empty">
          Nenhuma execução encontrada.
        </div>
      </aside>
      <article class="execution-panel">
        <div v-if="execucao">
          <header class="exec-head">
            <button class="mobile-back" @click="mobileDetail = false">←</button>
            <div>
              <small>{{ v(execucao, "tipoDisparo") }}</small>
              <h2>{{ v(execucao, "titulo") }}</h2>
              <p>{{ v(execucao, "resumo") }}</p>
            </div>
            <span :class="(v(execucao, 'status') || '').toLowerCase()">{{
              v(execucao, "status")
            }}</span>
          </header>
          <div class="exec-metrics">
            <div>
              <small>Início</small><b>{{ date(v(execucao, "iniciadaEm")) }}</b>
            </div>
            <div>
              <small>Duração</small
              ><b>{{ duracao(v(execucao, "duracaoMs")) }}</b>
            </div>
            <div>
              <small>Tokens</small><b>{{ num(v(execucao, "tokensTotal")) }}</b>
            </div>
            <div>
              <small>Custo</small><b>{{ money(v(execucao, "custoIa")) }}</b>
            </div>
          </div>
          <div class="exec-cols">
            <section>
              <h3>Linha do tempo</h3>
              <div v-for="e in eventos" :key="v(e, 'id')" class="event">
                <i></i>
                <div>
                  <b>{{ v(e, "titulo") }}</b>
                  <p>{{ v(e, "mensagem") }}</p>
                  <small>{{ date(v(e, "ocorridoEm")) }}</small>
                </div>
              </div>
              <div v-if="!eventos.length" class="empty">
                Nenhum evento registrado.
              </div>
            </section>
            <section>
              <h3>Resultados</h3>
              <div v-for="r in resultados" :key="v(r, 'id')" class="result">
                <span>{{ v(r, "tipo") }}</span
                ><b>{{ v(r, "titulo") }}</b>
                <p>{{ v(r, "descricao") || v(r, "conteudo") }}</p>
                <a v-if="v(r, 'arquivoUrl')" :href="v(r, 'arquivoUrl')"
                  >Baixar {{ v(r, "arquivoNome") }}</a
                ><a
                  v-if="v(r, 'urlExterna')"
                  :href="v(r, 'urlExterna')"
                  target="_blank"
                  >Abrir resultado ↗</a
                >
              </div>
              <div v-if="!resultados.length" class="empty">
                Nenhum resultado produzido.
              </div>
            </section>
          </div>
        </div>
        <div v-else class="empty central">
          Selecione uma execução para ver eventos e resultados.
        </div>
      </article>
    </section>
    <div v-if="!agente" class="loading">Carregando agente...</div>
  </main>
</template>
<script>
import axios from "axios";
export default {
  name: "AgenteDetalheView",
  data: () => ({
    agente: null,
    consumo: {},
    limite: {},
    erros: {},
    conversas: [],
    selecionada: null,
    mensagens: [],
    orcamento: null,
    execucoes: [],
    execucao: null,
    eventos: [],
    resultados: [],
    status: "",
    modo: "",
    busca: "",
    texto: "",
    arquivoId: null,
    enviando: false,
    atualizandoConversas: false,
    atualizacaoTimer: null,
    autoAtualizar: false,
    intervaloAtualizacaoSegundos: 10,
    mobileDetail: false,
    dataInicio: "",
  }),
  computed: {
    somenteFinalizadas() { return this.$route.name === 'AgenteFinalizadas'; },
    tipo() {
      return this.v(this.agente, "tipo");
    },
  },
  mounted() {
    this.carregar();
  },
  watch: {
    '$route.name'() {
      this.status = '';
      this.modo = '';
      this.busca = '';
      this.selecionada = null;
      this.mensagens = [];
      this.orcamento = null;
      if (
        this.tipo === 'INTERATIVO' &&
        ['AgenteDetalhe', 'AgenteFinalizadas'].includes(this.$route.name) &&
        this.$route.params.id
      ) this.conversasLoad();
    },
  },
  beforeDestroy() {
    if (this.atualizacaoTimer) {
      window.clearInterval(this.atualizacaoTimer);
    }
  },
  methods: {
    v(o, k) {
      if (!o) return null;
      return o[k] !== undefined ? o[k] : o[k[0].toUpperCase() + k.slice(1)];
    },
    tipoMidia(m) {
      return String(this.v(m, "mimeType") || this.v(m, "tipo") || "").toLowerCase();
    },
    ehAudio(m) {
      const tipo = this.tipoMidia(m);
      return tipo.startsWith("audio/") || tipo === "audio" || tipo === "áudio";
    },
    ehImagem(m) {
      const tipo = this.tipoMidia(m);
      return tipo.startsWith("image/") || tipo === "imagem" || tipo === "sticker";
    },
    ehMidia(m) {
      return this.ehAudio(m) || this.ehImagem(m) || ["video", "vídeo", "documento", "arquivo"].includes(this.tipoMidia(m));
    },
    urlArquivo(caminho) {
      if (!caminho || /^https?:\/\//i.test(caminho)) return caminho;
      const base = String(axios.defaults.baseURL || "").replace(/\/$/, "");
      return `${base}${caminho.startsWith("/") ? "" : "/"}${caminho}`;
    },
    async carregar() {
      const id = this.$route.params.id,
        r = await axios.get(`/Process/AdminAgentes/Agentes/${id}/Resumo`);
      Object.assign(this, r.data);
      if (this.tipo === "INTERATIVO") this.conversasLoad();
      else this.execucoesLoad();
    },
    async conversasLoad() {
      const agenteId = this.$route.params.id;
      if (
        !agenteId ||
        !['AgenteDetalhe', 'AgenteFinalizadas'].includes(this.$route.name)
      ) return;
      const q = new URLSearchParams({ pagina: 1, tamanhoPagina: 50 });
      if (this.somenteFinalizadas) q.set("status", "FINALIZADA");
      else if (this.status) q.set("status", this.status);
      if (this.modo) q.set("modo", this.modo);
      if (this.busca) q.set("busca", this.busca);
      this.conversas =
        this.v(
          (
            await axios.get(
              `/Process/AdminAgentes/Interativos/${agenteId}/Conversas?${q}`
            )
          ).data,
          "itens"
        ) || [];
    },
    async atualizarConversas() {
      if (this.tipo !== "INTERATIVO" || this.atualizandoConversas) return;
      this.atualizandoConversas = true;
      try {
        const conversaId = this.v(this.selecionada, "id");
        await this.conversasLoad();
        if (!conversaId) return;
        const atualizada = this.conversas.find(
          (item) => this.v(item, "id") === conversaId
        );
        if (atualizada) this.selecionada = atualizada;
        const rolar = this.$refs.messages &&
          this.$refs.messages.scrollHeight - this.$refs.messages.scrollTop -
          this.$refs.messages.clientHeight < 120;
        await this.carregarMensagens(conversaId, rolar);
      } finally {
        this.atualizandoConversas = false;
      }
    },
    configurarAtualizacaoAutomatica() {
      if (this.atualizacaoTimer) {
        window.clearInterval(this.atualizacaoTimer);
        this.atualizacaoTimer = null;
      }
      if (!this.autoAtualizar) return;
      const segundos = Math.max(3, Math.min(120, Number(this.intervaloAtualizacaoSegundos) || 10));
      this.intervaloAtualizacaoSegundos = segundos;
      this.atualizacaoTimer = window.setInterval(() => this.atualizarConversas(), segundos * 1000);
    },
    async carregarMensagens(conversaId, rolarAteFim = false) {
      if (!conversaId) return;
      const resposta = await axios.get(`/Process/AdminAgentes/Interativos/Conversas/${conversaId}/Mensagens?pagina=1&tamanhoPagina=100`);
      const novas = this.v(resposta.data, "itens") || [];
      const atual = this.mensagens.map((m) => `${this.v(m, "id")}|${this.v(m, "status")}`).join(",");
      const nova = novas.map((m) => `${this.v(m, "id")}|${this.v(m, "status")}`).join(",");
      if (atual !== nova) this.mensagens = novas;
      await this.$nextTick();
      if (rolarAteFim && this.$refs.messages) this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
    },
    async abrirConversa(c) {
      this.selecionada = c;
      this.mobileDetail = true;
      const conversaId = this.v(c, "id");
      await this.carregarMensagens(conversaId, true);
      try {
        const orcamentoResposta = await axios.get(
          `/Process/AdminAgentes/Interativos/Conversas/${conversaId}/Orcamento`
        );
        this.orcamento = orcamentoResposta.data || null;
      } catch (erro) {
        // O painel da conversa continua disponível durante implantação ou
        // indisponibilidade isolada do módulo de orçamentos.
        this.orcamento = null;
        console.warn("Não foi possível carregar o orçamento da conversa.", erro);
      }
      await this.$nextTick();
      if (this.$refs.messages) {
        this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
      }
      await axios.put(
        `/Process/AdminAgentes/Interativos/Conversas/${this.v(c, "id")}/Ler`
      );
    },
    async finalizarConversa() {
      if (!this.selecionada || !window.confirm('Finalizar esta conversa? Um novo contato do cliente iniciará um atendimento do zero.')) return;
      await axios.put('/Process/AdminAgentes/Interativos/Conversas/' + this.v(this.selecionada,'id') + '/Finalizar', { motivo:'Finalizada pelo painel' });
      this.selecionada = null; this.mensagens = []; this.orcamento = null;
      await this.conversasLoad();
    },
    async transferir(h) {
      await axios.put(
        `/Process/AdminAgentes/Interativos/Conversas/${this.v(
          this.selecionada,
          "id"
        )}/${h ? "Assumir" : "Devolver"}`,
        {}
      );
      this.selecionada = { ...this.selecionada, modo: h ? "HUMANO" : "AGENTE" };
      await this.conversasLoad();
    },
    async anexar(e) {
      const f = e.target.files[0];
      if (!f) return;
      const d = new FormData();
      d.append("arquivo", f);
      d.append("agenteId", this.$route.params.id);
      d.append("origem", "MENSAGEM_HUMANA");
      this.arquivoId = this.v(
        (await axios.post("/Process/AdminAgentes/Arquivos", d)).data,
        "id"
      );
    },
    async enviar() {
      if (!this.texto.trim() && !this.arquivoId) return;
      this.enviando = true;
      try {
        await axios.post(
          `/Process/AdminAgentes/Interativos/Conversas/${this.v(
            this.selecionada,
            "id"
          )}/Mensagens`,
          { texto: this.texto, arquivoId: this.arquivoId }
        );
        this.texto = "";
        this.arquivoId = null;
        await this.carregarMensagens(this.v(this.selecionada, "id"), true);
        await this.conversasLoad();
      } finally {
        this.enviando = false;
      }
    },
    async execucoesLoad() {
      const q = new URLSearchParams({ pagina: 1, tamanhoPagina: 50 });
      if (this.status) q.set("status", this.status);
      if (this.dataInicio) q.set("dataInicio", this.dataInicio);
      this.execucoes =
        this.v(
          (
            await axios.get(
              `/Process/AdminAgentes/Executores/${this.$route.params.id}/Execucoes?${q}`
            )
          ).data,
          "itens"
        ) || [];
    },
    async abrirExecucao(e) {
      this.mobileDetail = true;
      const id = this.v(e, "id");
      const [d, ev, r] = await Promise.all([
        axios.get(`/Process/AdminAgentes/Executores/Execucoes/${id}`),
        axios.get(
          `/Process/AdminAgentes/Executores/Execucoes/${id}/Eventos?pagina=1&tamanhoPagina=100`
        ),
        axios.get(
          `/Process/AdminAgentes/Executores/Execucoes/${id}/Resultados?pagina=1&tamanhoPagina=100`
        ),
      ]);
      this.execucao = d.data;
      this.eventos = this.v(ev.data, "itens") || [];
      this.resultados = this.v(r.data, "itens") || [];
    },
    progresso(k) {
      const map = {
          interacoes: ["interacoes", "limiteInteracoes"],
          execucoes: ["execucoes", "limiteExecucoes"],
          tokens: ["tokensTotal", "limiteTokensTotal"],
          armazenamento: ["armazenamentoMb", "limiteArmazenamentoMb"],
        },
        m = map[k],
        lim = this.v(this.limite, m[1]);
      return lim
        ? Math.min(100, Math.round((this.v(this.consumo, m[0]) / lim) * 100))
        : 0;
    },
    cor(p) {
      return p >= 100 ? "red" : p >= 80 ? "yellow" : "";
    },
    limiteTexto(k, s = "") {
      const x = this.v(this.limite, k);
      return x ? `Limite: ${this.num(x)}${s}` : "Sem limite definido";
    },
    num(x) {
      return Number(x || 0).toLocaleString("pt-BR");
    },
    money(x) {
      return Number(x || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    date(x) {
      return x
        ? new Date(x).toLocaleString("pt-BR", {
            dateStyle: "short",
            timeStyle: "short",
          })
        : "—";
    },
    hora(x) {
      return x
        ? new Date(x).toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
          })
        : "";
    },
    iniciais(x) {
      return (x || "?")
        .split(" ")
        .slice(0, 2)
        .map((a) => a[0])
        .join("")
        .toUpperCase();
    },
    duracao(x) {
      if (!x) return "—";
      return x < 1000 ? x + " ms" : (x / 1000).toFixed(1) + " s";
    },
  },
};
</script>
<style scoped>
.detail {
  padding: 22px 28px 55px;
  background: #f3f6f8;
  min-height: 100vh;
  color: #172331;
}
.back {
  border: 0;
  background: transparent;
  color: #2f7774;
  font-weight: 700;
  margin-bottom: 12px;
}
.top-actions { display:flex; justify-content:space-between; align-items:center; margin-bottom:12px }
.top-actions .back { margin-bottom:0 }
.knowledge { border:0; border-radius:9px; padding:10px 14px; background:#2f7774; color:#fff; font-weight:700; cursor:pointer }
.summary {
  background: #fff;
  border: 1px solid #dfe7ec;
  border-radius: 14px;
  padding: 20px;
  margin-bottom: 15px;
}
.heading {
  display: flex;
  align-items: center;
  gap: 13px;
}
.heading > div:nth-child(2) {
  flex: 1;
}
.heading small {
  font-weight: 800;
  color: #2f7774;
}
.heading h1 {
  margin: 2px 0;
}
.heading p {
  margin: 0;
  color: #64748b;
}
.heading > span {
  background: #e5f5ee;
  color: #24755c;
  border-radius: 16px;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 800;
}
.agent-icon {
  display: grid;
  place-items: center;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: #e8f3f2;
  color: #2f7774;
  font-size: 25px;
}
.summary-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  margin-top: 18px;
}
.summary-grid article {
  background: #f8fafb;
  border-radius: 9px;
  padding: 12px;
}
.summary-grid small,
.summary-grid em {
  display: block;
  color: #718096;
  font-style: normal;
  font-size: 11px;
}
.summary-grid b {
  display: block;
  margin: 4px 0;
}
.summary-grid article > div {
  height: 5px;
  background: #e3eaee;
  border-radius: 5px;
}
.summary-grid article > div i {
  display: block;
  height: 100%;
  background: #2f7774;
  border-radius: 5px;
}
.summary-grid i.yellow {
  background: #d09a42;
}
.summary-grid i.red {
  background: #cf5656;
}
.summary-grid .danger {
  background: #fff0f0;
}
.workspace {
  display: grid;
  grid-template-columns: 340px 1fr;
  background: #fff;
  border: 1px solid #dfe7ec;
  border-radius: 14px;
  min-height: 590px;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}
.workspace > * {
  min-width: 0;
}
.workspace > aside {
  border-right: 1px solid #dfe7ec;
  overflow: auto;
  max-height: 720px;
}
.filters {
  padding: 12px;
  border-bottom: 1px solid #e7edf1;
}
.filters input,
.filters select {
  width: 100%;
  padding: 9px;
  border: 1px solid #d3dde3;
  border-radius: 7px;
  margin-bottom: 6px;
  background: #fff;
}
.conversation,
.execution {
  display: grid;
  grid-template-columns: 40px 1fr auto;
  gap: 9px;
  padding: 13px;
  border-bottom: 1px solid #edf2f5;
  cursor: pointer;
}
.execution {
  display: block;
}
.conversation:hover,
.conversation.selected,
.execution:hover,
.execution.selected {
  background: #eef7f6;
}
.conversation.human {
  background: #fff4df;
  border-left: 4px solid #e59b2f;
}
.conversation.human.selected,
.conversation.human:hover {
  background: #ffedc7;
}
.avatar {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  background: #dcebea;
  color: #2f7774;
  border-radius: 50%;
  font-weight: 800;
}
.conversation header,
.execution header {
  display: flex;
  justify-content: space-between;
}
.conversation p,
.execution p {
  margin: 3px 0;
  color: #64748b;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.conversation small,
.conversation time,
.execution small {
  font-size: 10px;
  color: #94a3b8;
}
.conversation > i {
  background: #2f7774;
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  font-style: normal;
  font-size: 11px;
}
.chat,
.conversation-panel,
.execution-panel {
  height: 100%;
  min-width: 0;
  max-width: 100%;
}
.chat {
  display: flex;
  flex-direction: column;
}
.chat-head,
.exec-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  border-bottom: 1px solid #e5ecef;
}
.chat-head > div {
  flex: 1;
}
.chat-head small {
  display: block;
  color: #718096;
}
.chat-head > button,
.composer button {
  border: 0;
  background: #2f7774;
  color: #fff;
  padding: 9px 13px;
  border-radius: 7px;
  font-weight: 700;
}
.chat-head .secondary {
  background: #edf2f5;
  color: #475569;
}
.chat-refresh {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 18px;
  border-bottom: 1px solid #e5ecef;
  background: #f8fafb;
  color: #475569;
  font-size: 12px;
}
.chat-refresh label {
  display: flex;
  align-items: center;
  gap: 6px;
}
.chat-refresh input[type="number"] {
  width: 58px;
  padding: 5px 6px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
}
.chat-refresh button {
  border: 0;
  border-radius: 7px;
  padding: 7px 11px;
  background: #edf2f5;
  color: #475569;
  font-weight: 700;
  cursor: pointer;
}
.chat-refresh button:disabled {
  cursor: wait;
  opacity: 0.65;
}
.quote-card {
  margin: 10px 18px 0;
  padding: 12px 14px;
  border: 1px solid #cfe2df;
  border-radius: 10px;
  background: #f5fbfa;
  max-height: 190px;
  overflow: auto;
}
.quote-card header,
.quote-summary,
.quote-card footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.quote-card header div,
.quote-card header small { display: block; }
.quote-card header span {
  color: #23706d;
  background: #dff2ed;
  border-radius: 15px;
  padding: 4px 9px;
  font-size: 11px;
}
.quote-summary { margin: 9px 0; }
.quote-summary strong { font-size: 20px; }
.quote-items { display: flex; flex-wrap: wrap; gap: 6px; }
.quote-items span {
  padding: 5px 8px;
  background: #fff;
  border: 1px solid #dce9e7;
  border-radius: 7px;
  font-size: 12px;
}
.quote-items small { margin-right: 5px; color: #718096; }
.quote-card footer { margin-top: 9px; font-size: 12px; }
.messages {
  flex: 1;
  padding: 18px;
  overflow: auto;
  max-height: 550px;
  background: #f6f8f9;
  min-width: 0;
}
.message {
  width: fit-content;
  max-width: 72%;
  background: #fff;
  border-radius: 5px 13px 13px 13px;
  padding: 9px 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 7px #1723310c;
}
.message.saida {
  margin-left: auto;
  background: #dff0ed;
  border-radius: 13px 5px 13px 13px;
}
.message p {
  overflow-wrap: anywhere;
  word-break: break-word;
}
.message small {
  font-size: 9px;
  text-transform: uppercase;
  font-weight: 800;
  color: #2f7774;
}
.message p {
  margin: 3px 0;
  white-space: pre-wrap;
}
.message time {
  display: block;
  text-align: right;
  color: #94a3b8;
  font-size: 9px;
}
.message a {
  display: block;
  color: #2f7774;
}
.message-audio {
  display: block;
  width: min(320px, 100%);
  margin: 7px 0 4px;
}
.message-image {
  display: block;
  max-width: min(320px, 100%);
  max-height: 320px;
  margin: 7px 0 4px;
  border-radius: 8px;
  object-fit: contain;
}
.media-unavailable {
  display: block;
  margin: 5px 0;
  color: #64748b;
  font-size: 11px;
  font-style: italic;
}
.composer {
  display: grid;
  grid-template-columns: 35px 1fr 75px;
  gap: 7px;
  padding: 11px;
  border-top: 1px solid #dfe7ec;
}
.composer label {
  font-size: 20px;
  cursor: pointer;
}
.composer input {
  display: none;
}
.composer textarea {
  resize: none;
  border: 1px solid #d3dde3;
  border-radius: 8px;
  padding: 8px;
}
.execution header span,
.exec-head > span {
  font-size: 9px;
  font-weight: 800;
  padding: 4px 7px;
  border-radius: 12px;
  background: #edf2f5;
}
.execution header .concluida,
.exec-head > .concluida {
  background: #e5f5ee;
  color: #24755c;
}
.execution header .erro,
.exec-head > .erro {
  background: #fdeaea;
  color: #b43f3f;
}
.exec-head > div {
  flex: 1;
}
.exec-head small {
  color: #2f7774;
  font-weight: 800;
}
.exec-head h2 {
  margin: 2px 0;
}
.exec-head p {
  margin: 0;
  color: #64748b;
}
.exec-metrics {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding: 14px 18px;
}
.exec-metrics div {
  background: #f7f9fa;
  padding: 11px;
  border-radius: 8px;
}
.exec-metrics small,
.exec-metrics b {
  display: block;
}
.exec-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid #e5ecef;
}
.exec-cols > section {
  padding: 17px;
}
.exec-cols > section + section {
  border-left: 1px solid #e5ecef;
}
.event {
  display: flex;
  gap: 10px;
  padding: 9px 0;
}
.event > i {
  width: 9px;
  height: 9px;
  border: 2px solid #2f7774;
  border-radius: 50%;
  margin-top: 5px;
}
.event p,
.result p {
  margin: 3px 0;
  color: #64748b;
  font-size: 12px;
}
.event small {
  color: #94a3b8;
}
.result {
  border: 1px solid #e3eaee;
  border-radius: 8px;
  padding: 11px;
  margin-bottom: 8px;
}
.result > span {
  display: block;
  color: #2f7774;
  font-size: 9px;
  font-weight: 800;
}
.result a {
  display: block;
  color: #2f7774;
  font-weight: 700;
  font-size: 12px;
}
.empty,
.loading {
  padding: 28px;
  text-align: center;
  color: #94a3b8;
}
.central {
  display: grid;
  place-items: center;
  height: 100%;
}
.mobile-back {
  display: none !important;
}
@media (max-width: 900px) {
  .detail {
    padding: 14px 10px;
  }
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .workspace {
    display: block;
  }
  .workspace > aside {
    border: 0;
  }
  .workspace > aside.hidden,
  .conversation-panel.hidden {
    display: none;
  }
  .conversation-panel,
  .execution-panel {
    min-height: 600px;
  }
  .mobile-back {
    display: block !important;
  }
  .exec-cols {
    grid-template-columns: 1fr;
  }
  .exec-cols > section + section {
    border-left: 0;
    border-top: 1px solid #e5ecef;
  }
  .exec-metrics {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>

<style scoped>
.global-refresh{display:flex;justify-content:flex-end;align-items:center;gap:12px;padding:10px 14px;background:#fff;border:1px solid #dfe7ec;border-radius:10px;margin-bottom:10px;font-size:12px}.global-refresh label{display:flex;align-items:center;gap:6px}.global-refresh input[type=number]{width:60px}.finish{background:#b94747!important}.secondary{border:0;border-radius:7px;padding:8px 12px;font-weight:700;cursor:pointer}
</style>
